import { Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface GuideHeaderProps {
  title?: ReactNode
  description?: ReactNode
}

export const GuideHeader = ({ title, description, ...rest }: GuideHeaderProps): ReactElement => (
  <Styled.GuideHeaderWrapper {...rest}>
    {title && <Styled.Title variant="display">{title}</Styled.Title>}
    {description && <Text variant="bodyLG">{description}</Text>}
  </Styled.GuideHeaderWrapper>
)
